export default __webpack_public_path__ + "static/WP_App15-45d9d87b3c57ea17347351a44270e7ea.webp";